"use strict";
'use es6';
/*
 This is the same timeout period underscore uses per 
 https://github.com/jashkenas/underscore/blob/master/underscore.js#L835
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var delay = 0.1;

function _default(fn) {
  return setTimeout(fn, delay);
}

module.exports = exports.default;